G.Dirt = function(layer, cellX, cellY, hp) {
  G.BoardToken.call(this, layer, {
    tokenType: "dirt",
  }, cellX, cellY, hp);

  G.changeTexture(this, "dirt_"+this.hp);
};

G.Dirt.prototype = Object.create(G.BoardToken.prototype);

G.Dirt.prototype.onMatch = function() {
  G.sb("fxTop").dispatch('burstDirtAnim',this,this);
  this.hp--;
  if (this.hp > 0) {
    G.changeTexture(this,'dirt_'+this.hp);
  }else {
    this.remove();
  }
};

G.Dirt.prototype.onBooster = function() {
  this.onMatch();
  return false;
};